import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

// Deep Links in die Android-App:
//  - App Links  https://reverend.app/pay-return?…  (Rückkehr nach PayPal/Stripe)
//               https://reverend.app/p/<slug>      (geteilter Post)
//  - Eigenes Schema reverend://open?pin=success      (Fallback-Button auf der Webseite)
// Der Callback bekommt ein URL-Objekt. Bei Kaltstart kommt der Link über
// getLaunchUrl, bei laufender App über appUrlOpen – Dubletten werden verworfen.

export const APP_SCHEME = 'reverend'

let lastUrl = null
let lastAt = 0

export function onDeepLink(callback) {
  if (!Capacitor.isNativePlatform()) return () => {}

  const handle = raw => {
    if (!raw) return
    const now = Date.now()
    if (raw === lastUrl && now - lastAt < 5000) return
    lastUrl = raw
    lastAt = now
    try {
      callback(new URL(raw))
    } catch {
      console.warn('Invalid deep link:', raw)
    }
  }

  const listener = App.addListener('appUrlOpen', ({ url }) => handle(url))
  App.getLaunchUrl().then(res => handle(res?.url)).catch(() => {})

  return () => { listener.then(l => l.remove()) }
}

/** Pfad eines Deep Links, egal ob https://reverend.app/pay-return oder reverend://pay-return */
export function deepLinkPath(url) {
  // Bei reverend://pay-return steht "pay-return" im Host, nicht im Pfad
  return url.protocol === `${APP_SCHEME}:` ? `/${url.host}${url.pathname}`.replace(/\/$/, '') : url.pathname
}
